import templateUrl from './edit-employee-onboarding-profile.component.html';
import { ROSTER_SEPARATE_EDIT_PAGES } from '../roster-flags';
import { EmploymentRecordEditContext, EmploymentRecordHybridModel, EmploymentRecordInputModel } from './employment-record-editor/employment-record-edit-context.factory';
import { EmployeeIdentityResponse, CrudAccess, EmployeeProfileModel, SelectListDataItem, StateProvinceModel, EmployeeModel, BankInfoResponse } from '@herbjoy/apex-api-models';
import { IFormController, ITimeoutService, IQService, IPromise } from 'angular';
import { EventEmitter } from '../../../common/components/event-emitter';
import { FeatureManager } from '../../../core/feature-flags/feature-manager.service';
import { EmployeeService } from '../../../core/services';


export type EmployeeViewModel = Omit<EmployeeModel, "IcdOffices"> & {
    IcdOffices: Partial<EmploymentRecordInputModel>[];
}

interface SaveEvent {
    $event: {
        userProfile: EmployeeProfileModel;
        employeeAccount: EmployeeViewModel;
        onModelStateError(modelState: any): void;
    };
}

type OnSaveFn = (event: SaveEvent) => IPromise<any>;

export const EditEmployeeOnboardingProfileComponent = {
    templateUrl,
    //controller: EmployeeOnboardingProfileController,
    //controllerAs: "vm",
    bindings: {
        /** The employee whose employment record is being edited. */
        employee: "<",
        /** The employment record edit context providing options for dropdowns, etc. */
        context: "<",
        /** The identity of the current user. */
        identity: "<",
        /** Permissions representing user's role ability to edit the employee */
        roleAccess: "<",
        /** Permission representing whether the user can process payrolls */
        payrollAccess: "<",
        /** Indicates whether the edited employee is self-onboarding */
        isSelfSignUp: "<",
        /** Event to be emitted when the user requests viewing the minimum wage requirements at an office. */
        userProfile: "<",
        genderOptions: "<",
        stateProvinces: "<",
        showMinimumWageRequirements: "&onShowMinimumWageRequirements",
        featureManager: "<featureManagerSync",
        save: "&onSave",
        initOnboarding: "&onInitOnboarding",
        revokeOnboarding: "&onRevokeOnboarding"
    },
    controller: class {
        //@Input
        employee: EmployeeViewModel;
        //@Input
        context: EmploymentRecordEditContext;
        //@Input
        identity: EmployeeIdentityResponse;
        //@Input
        roleAccess: CrudAccess;
        //@Input
        payrollAccess: CrudAccess;
        //@Input
        userProfile: EmployeeProfileModel;
        //@Input
        genderOptions: SelectListDataItem[];
        //@Input
        isSelfSignUp: boolean;
        //@Input
        parentForm: IFormController;
        //@Output
        showMinimumWageRequirements: EventEmitter<{ employmentRecord: EmploymentRecordInputModel, employeeBankInfo: BankInfoResponse }>;
        //@Output
        initOnboarding: EventEmitter<boolean>;
        //@Output
        revokeOnboarding: EventEmitter<boolean>;
        //@Output
        save: OnSaveFn;
        //employee details
        userID: number;
        userNamePending: boolean;
        originalUserName: string;
        isSiteAdmin: boolean;
        isEditingSelf: boolean;
        isDisabled: boolean;
        //user profile
        requireDateOfBirth: boolean;
        requireGender: boolean;
        DEPT_900 = "900 1099";
        userGender: SelectListDataItem;
        //address
        stateProvinces: StateProvinceModel[];
        showExtension = true;
        //
        employeeID: number;
        editForm: IFormController;
        featureManager: FeatureManager;
        features: {
            [s: string]: boolean;
        };
        modelState: any;
        canInitOnboarding: boolean;
        constructor(private $timeout: ITimeoutService, private $q: IQService, private employeeService: EmployeeService) {
            'ngInject';
        }

        $onInit() {
            console.log(this.employee);
            console.log(this.identity);
            this.userID = this.identity && this.identity.EmployeeID;
            this.features = {};
            this.features.separateEditPages = this.featureManager.isEnabled(ROSTER_SEPARATE_EDIT_PAGES);
            this.canInitOnboarding = this.identity.IsSiteAdmin || this.identity.Roles.includes("Owner");
            if (!this.parentForm) {
                // Note, parentForm is the parent form, whereas editForm is the local form.
                window.onbeforeunload = () => {
                    if (this.editForm && this.editForm.$dirty) {
                        return "There are unsaved changes. Are you sure you want to abandon them?"
                    }
                }
            }

            if (this.isSiteAdmin === undefined) {
                this.isSiteAdmin = false;
            }

            if (this.isEditingSelf === undefined) {
                this.isEditingSelf = false;
            }

            if (this.isDisabled === undefined) {
                this.isDisabled = false;
            }

            this.requireDateOfBirth = !this.userProfile.CompensationProfile
                || this.userProfile.CompensationProfile.Name !== this.DEPT_900
                || (this.userProfile.CompensationProfile.Name === this.DEPT_900
                    && this.userProfile.HomeAddress.CountryID === 2);
            this.requireGender = !this.userProfile.CompensationProfile
                || this.userProfile.CompensationProfile.Name !== this.DEPT_900;
            this.userGender = this.genderOptions.find(gender => gender.Value === this.userProfile.GenderId);
        }

        onSave() {
            //if (this.editForm && this.editForm.$invalid) {
            //    alert("Please fix any validation errors and try again.");
            //    return;0
            //}
            this.save({
                $event: {
                    userProfile: this.userProfile,
                    employeeAccount: {
                        ...this.employee,
                        IcdOffices: this.employee.IcdOffices
                        //onModelStateError: modelState => {
                        //    this.modelState = modelState;
                        //}
                    },
                    onModelStateError: modelState => {
                        this.modelState = modelState;
                    }
                }
            })
                .then(() => {
                    this.editForm.$setPristine();
                })
                .catch(ex => {
                    this.modelState = ex.data ? ex.data.ModelState : null;
                });
        }
        onChangeGender() {
            this.userProfile.GenderId = this.userGender ?
                this.userGender.Value : null
        }

        onChangeUserName(userName) {
            this.userNamePending = true;
            this._validateUserNameAvailability(userName)
                .catch(() => { })
                .then(() => this.userNamePending = false)
                .then(() => {
                    if (this.editForm.$valid) {
                        //update user here
                        //this.change({ $event: this.user });
                    }
                });
        }

        private _validateUserNameAvailability(userName) {
            return this._isEmailAddressAvailable(userName)
                .then(available => this.editForm.UserName
                    .$setValidity("available", available));
        }

        private _isEmailAddressAvailable(userName) {
            if (userName === this.originalUserName) {
                return this.$q.resolve(true);
            }
            return this.employeeService.isEmailAddressAvailable(userName);
        }

        onChangeUserProfile() {
            this.mapSharedUserProfileFields(this.userProfile, this.employee);
        }

        private mapSharedUserProfileFields(source, target) {
            target.EmailAddress = source.EmailAddress;
            target.FirstName = source.FirstName;
            target.MiddleName = source.MiddleName;
            target.LastName = source.LastName;
        }

        $onChanges(changesObj) {
            this.employeeID = this.employee && this.employee.Id || null;
        }
        canAddNewOffice() {
            return this.employee.IcdOffices.every(office => office.HireDate && office.IcdOfficeID);
        }
        addNewOffice() {
            if (!this.canAddNewOffice()) {
                // Adding a new default office would result in a duplicate.
                return;
            }
            const office: Partial<EmploymentRecordInputModel> = {
                EmployeeStatusID: 3,
                EmployeeStatus: this.context.employmentStatuses.filter(function (status) {
                    return status.EmployeeStatusID === 3;
                })[0],
                AdministeredModules: [],
                Roles: [],
                RoleList: [],
                QualifiedPrograms: [],
                Divisions: [],
                TimeClock: true,
                RequireBreak: true,
                IsOnPayroll: true,
                CanDelete: true, // ie, the office is new and deleting it wouldn't cause problems.
                expanded: true
            };
            this.employee.IcdOffices.unshift(office);

            // Re-evaluate validation.
            this.context.changeRole(office as EmploymentRecordHybridModel);

            // Adding the new office doesn't make the employee form dirty until the office form is also made dirty.
            // Force the dirty state change here.
            this.editForm.$setDirty();
            this.$timeout(() => {
                office.icdOfficeEmployeeForm.$setValidity("at-least-one-role", false, undefined);
            })
        }

        removeOffice(i) {
            const office = this.employee.IcdOffices.splice(i, 1)[0];

            // Re-evaluate validation.
            this.context.changeRole(office as EmploymentRecordHybridModel);
        }
    }
}

